// extracted by mini-css-extract-plugin
export default {"scene7-image-icon":"configurator-web-scene7-image-icon","desktop":"configurator-web-desktop","active":"configurator-web-active","mobile":"configurator-web-mobile"};